import React from 'react'
import times from 'lodash/times'

import './style.css.scss'

const Skeleton = ({categoriesCount}) => (
  <div className="categories-skeleton">
    {times(categoriesCount, (i) => <span className="category-skeleton" key={i} />)}
  </div>
)

export default Skeleton
